/**
 * Script for All Pages
 *
 * @author Space-Time Inc.
 * @version 2022-10-18
 */

/**
 *  loading animation for front-page 
 *
 * @author Space-Time Inc.
 * @version 2023-08-23
 */

// const wrap     = document.querySelector('.page-template-front-page .loading-wrap');
const header   = document.querySelector('.page-template-front-page .site-header .main');
const title    = document.querySelector('.page-template-front-page .part-top-visual .site-title');
const caption  = document.querySelector('.page-template-front-page .part-top-visual .caption');


const loaderDisplay1 = function () {
	if(caption) {
		caption.classList.add('active');
	}
}

const loaderDisplay2 = function () {
	if(title) {
		title.classList.add('active');
	}
	if(header) {
		header.classList.add('active');
	}
	if(wrap) {
		wrap.classList.add('active');
	}
}

window.addEventListener('DOMContentLoaded', function () {
	
	if (!sessionStorage.getItem('disp')) {
		window.addEventListener('load', function () {
			if (agent.indexOf('safari') !== -1 && agent.indexOf('chrome') === -1){
				setTimeout(loaderDisplay1, 3000);
				setTimeout(loaderDisplay2, 4000);
			} else {
				setTimeout(loaderDisplay1, 5000);
				setTimeout(loaderDisplay2, 5500);

			}
		}, false);
		sessionStorage.setItem('disp', 'on');
	} else {
		if(caption) {
			caption.classList.add('active');
		}
		if(title) {
			title.classList.add('active');
		}
		if(header) {
			header.classList.add('active');
		}
		if(wrap) {
			wrap.classList.add('none');
		}
	}
});
/**
 * Minimum Viewport (JS)
 *
 * @author Space-Time Inc.
 * @version 2022-10-18
 */

(() => {
	const MIN_WIDTH = 360;

	const vp = document.querySelector('meta[name="viewport"]');
	function fn() {
		const v = window.outerWidth > MIN_WIDTH ? 'width=device-width,initial-scale=1' : `width=${MIN_WIDTH}`;
		if (vp.getAttribute('content') !== v) {
			vp.setAttribute('content', v);
		}
	}
	addEventListener('resize', throttle(fn), false);
	fn();

	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	
})();

/**
 * Back To Top
 *
 * @author Space-Time Inc.
 * @version 2022-10-18
 */

(() => {
	function init() {
		const OFFSET_Y = 0;

		const btn = document.getElementById('back-to-top');
		if (btn === null) return;
		const ph  = btn.parentElement;

		onScroll(scrollHandler);
		onResize(scrollHandler);
		if ('ontouchstart' in window) window.addEventListener('touchmove', scrollHandler);
		setTimeout(scrollHandler, 100);

		function scrollHandler() {
			// const btnR = btn.getBoundingClientRect();
			// const btnH = (btnR.bottom - btnR.top);

			const viewBottomY = window.innerHeight + OFFSET_Y/* - btnH*/;
			const footerTopY = ph.getBoundingClientRect().top;

			if (viewBottomY > footerTopY) {
				btn.style.transform = 'translateY(-' + (viewBottomY - footerTopY) + 'px)';
				btn.classList.remove('fixed');
			} else {
				btn.style.transform = '';
				btn.classList.add('fixed');
			}

			if (window.pageYOffset > window.innerHeight / 3) {
				btn.classList.remove('hidden');
			} else {
				btn.classList.add('hidden');
			}
		}
	}


	// -------------------------------------------------------------------------


	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	

	const resizeListeners = [];
	const scrollListeners = [];

	function onResize(fn, doFirst = false) {
		if (doFirst) fn();
		resizeListeners.push(throttle(fn));
	}

	function onScroll(fn, doFirst = false) {
		if (doFirst) fn();
		scrollListeners.push(throttle(fn));
	}

	document.addEventListener('DOMContentLoaded', () => {
		window.addEventListener('resize', () => {
			for (const l of resizeListeners) l();
		}, { passive: true });
		window.addEventListener('scroll', () => {
			for (const l of scrollListeners) l();
		}, { passive: true });
	});

	init();
})();

/**
 * Toggle Button
 *
 * @author Space-Time Inc.
 * @version 2023-02-21
 */

 document.addEventListener('DOMContentLoaded', () => {

	const btns = document.querySelectorAll('.user-content *[class^="button"]');

	for (let i = 0; i < btns.length; i += 1) {
		if (isToggleButton(btns[i])) setEventListener(btns[i]);
	}

	function isToggleButton(btn) {
		if (!btn.href || btn.href[btn.href.length - 1] !== '#') return false;
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		return f.classList.contains('frame') || f.classList.contains('frame-alt');
	}

	function setEventListener(btn) {
		btn.classList.add('toggle');
		initFrame(btn);
		btn.addEventListener('click', (e) => {
			if (btn.classList.contains('active')) {
				btn.classList.remove('active');
				setFrameVisible(btn, false);
			} else {
				btn.classList.add('active');
				setFrameVisible(btn, true);
			}
			e.preventDefault();
		});
	}

	function initFrame(btn) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		f.style.display = 'none';
		f.classList.add('hidden');
		setTimeout(() => { f.style.display = ''; }, 10);
	}

	function setFrameVisible(btn, visible) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		if (visible) {
			f.classList.remove('hidden');
		} else {
			f.classList.add('hidden');
		}
	}

});

/**
 * Lists by Terms
 *
 * @author Space-Time Inc.
 */

(function () {
	const MAX_COUNT = 6;

	const root = document.querySelector('.part-dynamic-archive-filter-achievement');
	if (!root) return;
	const terms = root.querySelectorAll('a.nav-link');
	const all = root.querySelector('a.all');

	const items = document.querySelectorAll('.list-item-achievement > .item-achievement');

	let current = 'all';


	all.style.pointerEvents = 'none';
	for( let i = 0; i < terms.length; i += 1) {
		setEventListener(terms[i]);
	}
	
	function setEventListener(term) {
		term.addEventListener('click', (e) => {

			e.preventDefault();
		
			const href = term.getAttribute('href');
			const slug = href.split('/').at(-1);
			current = 'achievement_category-' + slug;
			clearCurrent(e);
			all.classList.remove('first');
			e.target.classList.add('current');
			set_item_visible(current, MAX_COUNT);
			all.style.pointerEvents = 'auto';
			all.style.display = '';
		});
	}
	
	all.addEventListener('click', e => {
		e.preventDefault();

		current = 'all';
		e.target.classList.add('first');
		for( let i = 0; i < terms.length; i += 1) {
			terms[i].classList.remove('current');
		}
		set_item_visible(current, MAX_COUNT);
	});

	function set_item_visible(f, count) {
		let i = 0;
		for (; i < items.length; i += 1) {
			const it = items[i];

			const v = ('all' === f) || (it.classList.contains(f));

			if (v) {
				it.style.display = '';
				count -= 1;
	
			} else {
				it.style.display = 'none';
		
			}
			if (count === 0) break;
		}
		i += 1;
		for (; i < items.length; i += 1) {
			items[i].style.display = 'none';
		}
	}
	function clearCurrent(term){
		for (let i = 0; i < terms.length; i += 1) {
	
			if(terms[i].classList.contains('current')){
				terms[i].classList.remove('current');
			}
		}
	}
	document.addEventListener('DOMContentLoaded', () => {
		set_item_visible('all', MAX_COUNT);
		const list = document.querySelector('.list-item-achievement');
		list.classList.remove('first-view');
	});
})();

/**
* Lists by Terms
*
* @author Space-Time Inc.
*/

(function () {
   const MAX_COUNT = 6;

   const root = document.querySelector('.part-dynamic-archive-filter-news');
   if (!root) return;
   const terms = root.querySelectorAll('a.nav-link');
   const all = root.querySelector('a.all');


   const items = document.querySelectorAll('.list-item-news > .item-news');

   let current = 'all';


   all.style.pointerEvents = 'none';
   for( let i = 0; i < terms.length; i += 1) {
	   setEventListener(terms[i]);
   }

   function setEventListener(term) {
	   term.addEventListener('click', (e) => {

			e.preventDefault();
			const href = term.getAttribute('href');
			const slug = href.split('/').at(-1);
			current = 'news_category-' + slug;
			clearCurrent(e);
			all.classList.remove('first');
			e.target.classList.add('current');
			set_item_visible(current, MAX_COUNT);
			all.style.pointerEvents = 'auto';
			all.style.display = '';
	   });
   }
   
   all.addEventListener('click', e => {
   	e.preventDefault();
   	// all.style.display = 'none';
   	// sel.value = '#';
   	current = 'all';
	e.target.classList.add('first');
	for( let i = 0; i < terms.length; i += 1) {
		terms[i].classList.remove('current');
	}
   	set_item_visible(current, MAX_COUNT);
   });

   function set_item_visible(f, count) {
	   let i = 0;
	   for (; i < items.length; i += 1) {
		   const it = items[i];

		   const v = ('all' === f) || (it.classList.contains(f));

		   if (v) {
			   it.style.display = '';
			   count -= 1;
		   } else {
			   it.style.display = 'none';
		   }
		   if (count === 0) break;
	   }
	  i += 1;
	   for (; i < items.length; i += 1) {
		   items[i].style.display = 'none';
	   }
   }

   function clearCurrent(term){
	for (let i = 0; i < terms.length; i += 1) {

		if(terms[i].classList.contains('current')){
			terms[i].classList.remove('current');
		}
	}
}
   document.addEventListener('DOMContentLoaded', () => {
	   set_item_visible('all', MAX_COUNT);
	   const list = document.querySelector('.list-item-news');
	   list.classList.remove('first-view');
   });
})();

/**
 * Visual Change
 *
 * @author Space-Time Inc.
 * @version 2023-08-16
 */


const target = document.getElementById("js-scroll");



const observer = new IntersectionObserver(
	showElements, 
	{
		rootMargin: "40% 0px -5% 0px",
		threshold: buildThresholdList(100)
	   //threshold: 1
	}
	);
if(target) { observer.observe(target); }

function buildThresholdList(num) {
	let thresholds = [];
	let numSteps = num || 20;

	for (let i = 1.0; i <= numSteps; i++) {
	  let ratio = i / numSteps;
	  thresholds.push(ratio);
	}
  
	thresholds.push(0);
	return thresholds;
}

  function showElements(entries) {
	entries.forEach((entry) => {
	  if (entry.isIntersecting) {
		const anims = document.querySelectorAll('.anim-bg');

		let ratio = entry.intersectionRatio * 100;

			// for (let i = 0; i < anims.length; i += 1 ) {
			// 	anims[i].style.backgroundImage = `
			// 	linear-gradient(
			// 	90deg,
			// 	rgba(64, 194, 201, ${10 + ratio/2}%) 0%,
			// 	rgba(64, 194, 201, ${10 + ratio/2}%) 50%,
			// 	rgba(197, 255, 118, ${10 + ratio/2}%) 100%
			//   )`;
			 for (let i = 0; i < anims.length; i += 1 ) {
				anims[i].style.backgroundImage = `
				linear-gradient(
				90deg,
				rgb(64, 194, 201, 0.4) ${0 - ratio}%,
				rgb(64, 194, 201, 0.4) ${100 - ratio}%,
				rgb(197, 255, 118, 0.4) ${200 - ratio}%
			  )`;
				// 'linear-gradient(90deg,rgb(64, 194, 201) '${0 - ratio}'%, rgb(64, 194, 201) '${100 - ratio}'%, rgb(197, 255, 118) '${200 - ratio}'%)';
				//anims[i].style.opacity =  ratio + '%';
			}
		}
  });
}

/**
 * Visual Change
 *
 * @author Space-Time Inc.
 * @version 2023-08-16
 */

// const targets = document.getElementsByClassName('fade');//
const targets = document.querySelectorAll(".fade");

for(let i = targets.length; i--;){
 let observer = new IntersectionObserver((entries, observer) => {
  for(let j = entries.length; j--;){
   if (entries[j].isIntersecting) {
    entries[j].target.classList.add('active');
    observer.unobserve(entries[j].target);
//    } else{
//     entries[j].target.classList.remove('active');
   }
  } 
}, 
{//
    rootMargin: '-20%'
});
 observer.observe(targets[i]);
}

/**
 * Hamburger (JS)
 *
 * @author Space-Time Inc.
 * @version 2023-07-04
 */

document.addEventListener('DOMContentLoaded', () => {
	const sms = document.querySelectorAll('.part-hamburger li > *:first-child + ul');
	for (const sm of sms) {
		const label = sm.previousElementSibling;
		label.classList.add('has-child');
		label.addEventListener('click', () => {
			label.classList.toggle('open');
			sm.classList.toggle('open');
		});
	}

	const ham      = document.querySelector('.part-hamburger');
	const btnClose = document.querySelector('#close-hamburger');
	if (ham && btnClose) {
		btnClose.addEventListener('click', () => {
			ham.classList.remove('open');
			document.body.style.overflow = '';
		});
	}

	const btnOpen = document.querySelector('#open-hamburger');

	if (btnOpen) {
		btnOpen.addEventListener('click', () => {
			ham.classList.add('open');
			document.body.style.overflow = 'hidden';
		});
	}
});


